export default __webpack_public_path__ + "static/media/addFolder.224278f5.svg";